module.exports = __webpack_public_path__ + "static/media/angry.952947f0.png";